var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9A",
    stroke: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7,52.0608c-2.2485-1.8528-3-8.2556-3-11.3966c0-2.7896,1.1307-10.3151,2.9588-12.1432c0,0,2.6586-1.1324,4.0412,0 c4.5288,3.7092,13.6575,12.2147,25.0042,0c0,0,17.5773,8.3421,22.3198,9.5458c8.1427,2.0668,8.4167,4.1197,8.4167,6.8223 c0,8.6515-10.0838,7.5391-16.8102,7.1718C46.2237,51.8584,11.1297,52.2863,7,52.0608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0CFCE",
    stroke: "none",
    d: "M7,45.8841c0,0,16.134-1.5287,25.4956,1.0426s28.3456,0.2299,28.3456,0.2299l5.2681-0.0261 c0,0-0.9366,5.7896-5.523,5.7896S6,51.1287,6,51.1287S2.6177,46.4381,7,45.8841z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7,52.0608c-2.2485-1.8528-3-8.2556-3-11.3966c0-2.7896,1.1307-10.3151,2.9588-12.1432c0,0,2.6586-1.1324,4.0412,0 c4.5288,3.7092,13.6575,12.2147,25.0042,0c0,0,17.5773,8.3421,22.3198,9.5458c8.1427,2.0668,8.4167,4.1197,8.4167,6.8223 c0,8.6515-10.0838,7.5391-16.8102,7.1718C46.2237,51.8584,11.1297,52.2863,7,52.0608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M8,46.8163c0,0,15.134-2.4608,24.4956,0.1105s28.3456,1.2299,28.3456,1.2299"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.4419,
    x2: 35.3703,
    y1: 35.9583,
    y2: 41.8963,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.5264,
    x2: 41.9942,
    y1: 37.7606,
    y2: 41.8963,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7,52.0608c-2.2485-1.8528-3-8.2556-3-11.3966c0-2.7896,1.1307-10.3151,2.9588-12.1432c0,0,2.6586-1.1324,4.0412,0 c4.5288,3.7092,13.6575,12.2147,25.0042,0c0,0,17.5773,8.3421,22.3198,9.5458c8.1427,2.0668,8.4167,4.1197,8.4167,6.8223 c0,8.6515-10.0838,7.5391-16.8102,7.1718C46.2237,51.8584,11.1297,52.2863,7,52.0608"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoe);
export default __webpack_public_path__ + "static/media/shoe.d6862cc0f7a90cc79c74d26e3980d6e9.svg";
export { ForwardRef as ReactComponent };